import { assertUnreachable, isDefined, isNotDefined } from '@sgme/fp';

import type { AccumulatorScheduleLine } from '@/store/targetAccumulator/state.ts';
import type { SchedulerCalendarProperty } from '@/store/targetAccumulator/utils.ts';
import { formatDateTimeWithLocale } from '@/utils/date.ts';

export function headerExport(property: Exclude<SchedulerCalendarProperty, 'deleteIcon'>) {
  switch (property) {
    case 'PIVOT':
      return 'accumulator.scheduler.calendar.pivot';
    case 'amount':
      return 'accumulator.scheduler.calendar.notionalToExport';
    case 'fixingDate':
      return 'accumulator.scheduler.calendar.fixingDate';
    case 'leverageAmount':
      return 'accumulator.scheduler.calendar.leverageAmountToExport';
    case 'paymentDate':
      return 'accumulator.scheduler.calendar.paymentDate';
    case 'strike':
      return 'accumulator.scheduler.calendar.strike';
    case 'strikeUp':
      return 'accumulator.scheduler.calendar.strikeUp';
    case 'strikeDown':
      return 'accumulator.scheduler.calendar.strikeDown';
    case 'ekiDown':
      return 'accumulator.scheduler.calendar.ekiDown';
    case 'ekiUp':
      return 'accumulator.scheduler.calendar.ekiUp';
    case 'EKI':
      return 'accumulator.scheduler.calendar.EKI';
    default:
      assertUnreachable(property, `Unknow strike type ${property}`);
  }
}

export function downloadCSV(content: string) {
  const uri = `data:text/csv;charset=utf-8,${encodeURIComponent(content)}`;
  const link = document.createElement('a');
  link.href = uri;
  link.className = 'd-none';
  link.download = `FX ${formatDateTimeWithLocale(new Date(), 'en')}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
}

export const mapScheduleValues = (
  schedule: Record<string, AccumulatorScheduleLine | null> | null | undefined,
  calendarProps: SchedulerCalendarProperty[],
) => {
  if (isNotDefined(schedule)) {
    return [];
  }

  return Object.values(schedule)?.map((value) => {
    if (isDefined(value)) {
      return Object.entries(value).reduce(
        (acc, [key, usedValue]) => {
          if (calendarProps.includes(key as Partial<SchedulerCalendarProperty>)) {
            acc[key] = usedValue;
          }
          return acc;
        },
        {} as Record<string, string | number | null>,
      );
    }
    return {};
  });
};
